const MAX_TITLE_LENGTH = 35;
const TRUNCATED_TEXT_LENGTH = 30;

export const truncateText = (text: string) =>
  text.length > MAX_TITLE_LENGTH
    ? `${text.slice(0, TRUNCATED_TEXT_LENGTH)}…`
    : text;
